var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.5 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Fire and Alarm System") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.6 44.1c-1.6 0.9-2.8 1.4-3.4 1.6-2.4-1-18-7.9-18-25.1v-15.2l18-3.3 18.1 3.3v15.2c0 1.5-0.1 2.9-0.4 4.2 0.4 0.9 0.9 1.7 1.4 3 0.6-2.2 0.9-4.6 0.9-7.2v-16.9l-20.1-3.6-20.1 3.7v16.9c0 19.9 19.7 27 19.8 27.2h0.3l0.3-0.1c0.1 0 1.9-0.7 4.4-2.1-0.4-0.5-0.9-1-1.2-1.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.6 14.7v-2.3c0-2.6-2.1-4.7-4.7-4.7s-4.7 2.1-4.7 4.7v2.3h-2.8v8.6c0 2.1 1.8 3.9 3.9 3.9h7.1c2.2 0 3.9-1.7 3.9-3.9v-8.6h-2.7zm-7.9-2.3c0-1.7 1.4-3.1 3.2-3.1s3.2 1.4 3.2 3.1v2.3h-6.3v-2.3zm9.1 10.9c0 1.3-1.1 2.3-2.4 2.3h-7.1c-1.3 0-2.4-1-2.4-2.3v-7h11.9v7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.3 22.4c0.1 0.2 0.3 0.4 0.6 0.4s0.5-0.2 0.6-0.4l0.7-1.9c0.2-0.7-0.4-1.3-1.3-1.3-0.8 0-1.5 0.6-1.3 1.3l0.7 1.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30 45.1c-1.3-0.8-2.2-2.1-2.2-3.6-0.1-2.9 1.9-4.3 3.1-6.3 1.7-2.8 1.2-4.6 1.2-4.6s1.4 0.8 2.3 3.8c0.3 0.9 0.3 1.8 0.2 2.6-0.1 2.1-1 4-1 4s1.6-0.3 2-3.2c0.7 0.8 1.4 1.8 1.5 3 0.1 2-1 3.8-2.8 4.6 3.1-0.7 5.2-3.3 6-5.2 1-2.4 0.7-4.5 0.5-6.4-0.2-2.5 0.7-4.4 0.7-4.4s-1.7 0.5-2.9 2.5c-0.6 0.9-0.8 2.3-0.8 2.3s0.1-1.2-0.7-3.5c-0.8-2.2-1.5-3-2-4.6-0.6-2.2 0.7-4.3 0.7-4.3s-5 0.9-7.3 5.3c-2 3.9-1.2 6.2-1.2 6.2s-0.9-0.8-1.3-1.9-0.3-2.1-0.3-2.1-3.6 4-1.8 8.9c1.1 3.7 3.4 6 6.1 6.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.ed583bdb18d5d5e3a189418a2aa24f22.svg";
export { ForwardRef as ReactComponent };